import type { WCardVariationColorSummaryView } from '@zola/svc-web-api-ts-client';
import type { SeoColor } from '~/cards/constants/seoColors';
import type { CardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export type CardMetaData = {
  product_id?: string;
  sku?: string;
  sku_id?: string;
  category?: string;
  brand?: string;
  name?: string;
  variant?: string;
  price?: string; // toFixed returns a string
  quantity?: number;
  url?: string;
  image_url?: string;
  location?: string;
  section?: string;
  position?: number;
};

export type CardListing = {
  motif_color_recommendations: Record<string, string>;
  color_recommendations: Record<SeoColor, string>;
  collaborator: string;
  colors: WCardVariationColorSummaryView[];
  initialColor?: string;
  foil: boolean;
  key: string;
  letterpress: boolean;
  medium: string;
  min_price_cents: number;
  name: string;
  searchIndex: number;
  singleSampleAvailable: boolean;
  singleSampleSku: string;
  suiteName: string;
  suiteUUID: string;
  thirdparty: boolean;
  type: CardType;
  uuid: string;
  thirdParty?: boolean;
};

export type Color = {
  default_variation_uuid: string;
  label: string;
  nrf_color_code_label: string;
  plp_front_image_url: string;
  value: string;
};

export type Ad = {
  type: 'Ad';
  uuid: string;
};

export type Digital = {
  type: 'Digital';
  uuid: string;
};

export type Sample = {
  type: 'sample';
  uuid: string;
};

export type QRModule = {
  type: 'qrModule';
  uuid: string;
};

export type MultiSampleTile = {
  uuid: 'multiSampleTile';
  multisample: true;
  type: 'multiSampleTile';
};

export type CardListingOptions = CardListing | MultiSampleTile | Ad | Sample | Digital | QRModule;

export type Motif = {
  display_order: number;
  key: string;
  name: string;
  uuid: string;
};

export type Shape = {
  key: string;
  value: string;
  label: string;
  icon: string;
};

export type Collaborator = {
  key: string;
  slug: string;
  label: string;
};

export const PARAM_KEY_TO__FILTER: Record<string, string> = {
  has_foil: 'foil',
  has_custom_photo: 'customphoto',
  has_no_custom_photo: 'nocustomphoto',
  has_magnet: 'magnet',
  is_landscape: 'landscape',
  is_portrait: 'portrait',
  is_square: 'square',
  is_vow_renewal: 'elopementandvowrenewal',
  featured_artist: 'featuredArtist',
  is_letterpress: 'is_letterpress',
  single_sample_available: 'multisampleenabled',
};
